import React, {useState , useCallback} from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import {useList} from 'react-use';
import lodash from 'lodash';

import useDisableScrollDocument from '../../../useHook/useDisableScrollDocument'

import {deleteCustomReport, getCustomeLeaderBoard} from "../../../actions/leader-board";

function CustomListModal(props) {
    useDisableScrollDocument();

    const {list, onCloseModal} = props;
    const [listCustom, listCustomHelper] = useList(list);

    const dispatch = useDispatch();

    const [selectedItem, setSelectedItem] = useState(null);
    const [error, setError] = useState('');

    const onDelete = useCallback(async (id) => {
        try {
            await dispatch(deleteCustomReport(id));
            onCloseModal();
            dispatch(getCustomeLeaderBoard());
            setSelectedItem(null);
        } catch (error) {
            setError('Something went wrong');
        }
    }, []);

    const onChangeName = useCallback((value, custom, index) => {
        listCustomHelper.updateAt(index, {
            ...custom,
            name: value,
        })
    }, []);

    const onSave = useCallback(() => {
        const diff = lodash.differenceWith(listCustom, list, lodash.isEqual);
        props.onSave(diff);
    }, [listCustom])

    return <div className="wrap-custome-edit">
        <div className="custome-edit">
            <h4>カスタムレポート管理</h4>
            <ul>
                {listCustom.map((custom, index) => {
                    const active = selectedItem && selectedItem.id === custom.id;
                    return <li key={custom.id} className={classNames(active && 'focus-item')} onClick={() => setSelectedItem(custom)}>
                        <div style={{alignItems: 'center', display: 'flex'}}>
                            <input type='text' onChange={(e) => onChangeName(e.target.value, custom, index)} placeholder={'name'} value={custom.name} readOnly={!active} />
                            {active && <img alt="delete" src="/img/ic_delete2.png" onClick={() => onDelete(custom.id)}/>}
                        </div>
                    </li>
                })}
            </ul>
            {error && <div className={'message-error'} style={{fontSize: 14, textAlign: 'left', padding: '10px 15px'}}>
                {error}
            </div>}
            <div>
                <button onClick={onCloseModal}>キャンセル</button>
                <button onClick={onSave}>完了</button>
            </div>
        </div>
    </div>
}

export default CustomListModal;